import { FC } from "react";
import { Form, Input } from "antd";
import Carrier from "@Components/Carrier/Carrier";
import { withFloatingLabel } from "src/HOC";
import FlightSelectContent from "../../FlightSelectContent/FlightSelectContent";

const FloatingInput = withFloatingLabel(Input);

const DestinationComponentMob: FC<any> = ({ name, icon: Icon, label, hasError, ...props }) => {
  const value = Form.useWatch(name);

  return (
    <Carrier
      label={label}
      renderTrigger={({ open }) => (
        <div className={`border-border-default border-b flex w-full flex-1 items-center gap-1 px-1 ${hasError ? "text-font-danger" : "text-font-minimal"}`}>
          <Icon className="h-4! w-4!" />
          <FloatingInput
            label={label}
            readOnly
            value={value?.label}
            onClick={open}
            className="text-font-strong! border-none! outline-none! font-semibold shadow-none! pt-5! pb-1! px-3! w-full cursor-pointer"
          />
        </div>
      )}
      renderSheet={({ close }) => <FlightSelectContent name={name} icon={Icon} label={label} closeSheet={close} {...props} />}
    />
  );
};

export default DestinationComponentMob;
